module.exports = __webpack_public_path__ + "media/images/top/magazine-sample02-f9f9abe725662e2365059f07c04057bb.jpg";